import { type RouteRecordRaw } from 'vue-router'

import { eModules } from '@/constants'
import Layout from '@/layout/index.vue'

export const performanceDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/performance-dashboard',
    components: {
      default: () => import('../views/dashboard.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'Performance Dashboard',
    meta: {
      title: 'Performance Dashboard', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PERFORMANCE_DASHBOARD],
    },
  },
  {
    path: '/performance-dashboard/:id',
    components: {
      default: () => import('../views/board.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'board',
    meta: {
      title: 'Board', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PERFORMANCE_DASHBOARD],
    },
  },
  {
    path: '/performance-dashboard/:id/print',
    components: {
      default: () => import('../views/board-print.vue'),
      navbar: () => import('../views/navbar/index.vue'),
      // navbar: () => import('../views/navbar/index.vue')
    },
    name: 'board-print',
    meta: {
      title: 'Board print', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PERFORMANCE_DASHBOARD],
    },
  },
]
